import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined';
import Button from 'antd/lib/button';
import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router';

import styles from './MobileHeader.module.css';

import { GLOBAL_SEARCH_KEY } from '../../side-nav/sidenav-constants';
import { useUserInfo } from '../user-info/user-info-hook';

export interface MobileHeaderViewDelegate {
  onGlobalSearchShowOnMobile(): void;

  onGlobalSearchHideOnMobile(): void;
}

function MobileHeaderView() {
  const navigate = useNavigate();
  const { userInfoModel } = useUserInfo();

  const goToGlobalSearch = useCallback(() => {
    if (location.pathname !== GLOBAL_SEARCH_KEY) {
      void navigate(GLOBAL_SEARCH_KEY);
    }
  }, [navigate]);

  const {
    branding: { longName },
  } = window.CONFIG;

  return (
    <>
      <Link to="/" className={styles.titleBtn}>
        <span className="mobile-header-title">{longName}</span>
      </Link>
      {userInfoModel.workbenchAllowed ? (
        <Button
          className={`${styles.searchBtn} mobile-header-search-btn`}
          icon={<SearchOutlined className={styles.searchBtnIcon} />}
          onClick={goToGlobalSearch}
        />
      ) : (
        <div></div>
      )}
    </>
  );
}

export function MobileHeader() {
  return <MobileHeaderView />;
}
